<script>
/* eslint-disable no-undef */
import axios from 'axios'
import BaseApp from "./BaseApp.vue";

export default {
    name: 'BxBaseApp',
    extends: BaseApp,
    methods: {
        initData(additionalSendData) {
            this.$root.getDataElement = this.getDataElement;

            return new Promise((resolve, reject) => {
                const t = this;
                const dataVarName = t.$options.name + 'Data'
                if (Object.hasOwnProperty.call(window, dataVarName) && window[dataVarName]) {
                    for (let key in window[dataVarName]) {
                        t[key] = window[dataVarName][key];
                    }

                    window[dataVarName] = null;

                    t.$nextTick(function () {
                        resolve()
                    })
                } else {
                    let sendData = {
                        sessid: t.sessid
                    }
                    if (typeof additionalSendData === 'object') {
                        Object.assign(sendData, additionalSendData);
                    }

                    axios.post(t.domain + '/api/' + t.pascalCaseToKebab(t.$options.name) + '/getData/', null, {
                        body: sendData,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    }).then(function (response) {
                        for (let key in response.data.data) {
                            if (key !== 'status') {
                                t[key] = response.data.data[key]
                            }
                        }

                        t.$nextTick(function () {
                            resolve()
                        })
                    }).catch(() => {
                        reject()
                    });
                }
            })
        },
    }
}
</script>